// extracted by mini-css-extract-plugin
export default {"note_container":"Updates_note_container__v18Dc","open":"Updates_open__6XcXm"};